import React, { useState } from "react";
import { Tabs } from "antd";
import Products from "../Products/Products";
import Base from "../../Config/Base";
import { Footer } from "../footer/footer";
import Preferences from "./Preferences";
import OrgSettings from "./OrgSettings";

// import Preferences from "./Preferences";
// import OrgSettings from "./OrgSettings";

const Settings = () => {
  const [activeTab, setActiveTab] = useState("products");

  const items = [
    {
      key: "products",
      label: (
        <span>
          <i className="fa-solid fa-box-open me-2"></i>
          Products
        </span>
      ),
      children: <Products />,
    },
    {
      key: "org-settings",
      label: (
        <span>
          <i className="fa-solid fa-building me-2"></i>
          Org Settings
        </span>
      ),
      children: <OrgSettings />,
    },
    {
      key: "preferences",
      label: (
        <span>
          <i className="fa-solid fa-sliders me-2"></i>
          Preferences
        </span>
      ),
      children: <Preferences />,
    },
  ];

  return (
    <Base>
      <style>
        {`
          .settings-tabs .ant-tabs-tab {
            font-weight: 500;
            color: #6c757d;
            transition: .3s;
          }

          .settings-tabs .ant-tabs-tab:hover {
            color: #1B2850;
          }

          .settings-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
            color: #1B2850 !important;
            font-weight: 600;
          }

          .settings-tabs .ant-tabs-ink-bar {
            background: #1B2850;
            height: 3px;
          }
        `}
      </style>

      <div className="card shadow-sm border-0">
        <div className="card-body">
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            items={items}
            animated
            className="settings-tabs"
          />
        </div>
      </div>
      <Footer></Footer>
    </Base>
  );
};

export default Settings;
